import { HTMLAttributes, memo, PropsWithChildren } from 'react';
import cls from 'classnames';

import styles from './FormGroup.module.css';

function FormGroup(props: PropsWithChildren<HTMLAttributes<HTMLDivElement>>) {
  const { className, children, ...rest } = props;

  return (
    <div className={cls(styles.formGroup, className)} {...rest}>
      {children}
    </div>
  );
}

export default memo(FormGroup);
